// Public sitenin (tanıtım sitesi) istemci giriş noktası.
//
// Kule'den TAMAMEN ayrıdır: farklı layout (app/views/layouts/public.html.erb), farklı CSS
// (eski sitenin CSS'i, Tailwind yok) ve farklı sayfa çözücü (app/frontend/public/pages).
// Kule entrypoint'i app/frontend/entrypoints/inertia.tsx'tir ve app/frontend/pages'e bakar.

import { createInertiaApp, router } from '@inertiajs/react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { resolvePublicPage } from '../public/lib/resolvePage'
import { initTracking, trackPageView } from '../public/lib/tracking'
// Stil dosyası burada import EDİLMEZ; layout'ta <link> olarak yüklenir (bkz. entrypoints/public.css).

// Sayfa görüntüleme (Meta Pixel / GA4): ilk yüklemeyi layout'taki kod sayar, gezintileri biz.
initTracking()
router.on('navigate', () => trackPageView())

void createInertiaApp({
  resolve: resolvePublicPage,
  setup({ el, App, props }) {
    if (!el) return

    // SSR açıkken sunucudan gelen HTML'e bağlanılır; SSR kapalıysa (ör. test ortamı, SSR
    // sunucusu çökmüşse) #app boş gelir ve hydrate etmek React #418 hatası verir.
    if (el.hasChildNodes()) {
      hydrateRoot(el, <App {...props} />)
    } else {
      createRoot(el).render(<App {...props} />)
    }
  },
  progress: { color: '#d05d3c' },
})
